'use strict';
const _ = require('lodash');
const $ = require('jquery');
const Backbone = require('backbone');
const PubSub = require('./../PubSub');
const template = require('../templates/auth.ejs');

module.exports = Backbone.View.extend({
    className: 'view-auth',
    events: {
        'click .facebook': 'facebookLogin',
        'click .google': 'googleSignIn',
        'input .email': 'verifyEmailInput',
        'focus .email': 'verifyEmailInput',
        'keypress .email': 'verifyEmailInput',
        'keyup .email': 'verifyEmailInput',
        'click .btn-close': 'closeModal',
        'click button[type="submit"]': 'validateForm',
        'submit .auth-form': 'validateForm',
        'click a': 'handleAnchorClick'
    },
    /**
     *
     */
    initialize: function (options) {
        _.bindAll(this, 'render');

        options = options || {};

        this.userSelection = null;
        this.nativeApp = options.native;
        this.google = options.google;
        this.facebook = options.facebook;
    },
    /**
     *
     */
    render: function () {
        var model = {
            copy: this.model,
            native: this.nativeApp
        };
        this.$el.html(template(model));
        return this;
    },
    /**
     * [renderedToDom description]
     * @return {[type]} [description]
     */
    renderedToDom: function() {
        const btn = this.$el.find('#gSignIn').get(0);
        this.google.renderButton(btn, this.googleSignIn.bind(this));
    },
    /**
     *
     */
    validateForm: function(e) {
        e.preventDefault();
        e.stopPropagation();
        this.authenticateEmail(e);
    },
    /**
     * [verifyEmailInput description]
     * @param  {[type]} e [description]
     * @return {[type]}   [description]
     */
    verifyEmailInput: function(e) {
        e.stopPropagation();

        if(e.currentTarget.value.length > 40) {
            e.preventDefault();
            return false;
        }

        if($('input[type="email"]').hasClass('error-formbox') && e.currentTarget.value.length === 0) {
            $('input[type="email"]').removeClass('error-formbox');
            this.$('.error-message').hide();
        }
    },
    /**
     * Handle checkbox clicks for toggling disabled buttons
     */
    checkboxClick: function() {
        var checkbox = this.$el.find('input[type="checkbox"]');
        if(!checkbox.is(':checked')) this.$('#gSignIn').removeClass('disabled');
        else this.$('#gSignIn').addClass('disabled');
    },
    /**
     * Validate optin checkbox when user submits
     */
    validateCheckbox: function(){
        var checkbox = this.$el.find('input[type="checkbox"]');

        if(!checkbox.is(':checked')) {
            this.$('.error-message-checkbox').show();
            this.$el.find('.checkbox-parent').addClass('error-input');
            return false;
        }

        this.$('.error-message-checkbox').hide();
        this.$el.find('.checkbox-parent').removeClass('error-input');
        return true;
    },
    /**
     *
     */
    facebookLogin: function(e) {
        var omParams = { name: 'facebook login button', section: 'login-modal', url: window.location.href };

        PubSub.trigger('linkClick', omParams);

        this.facebook.login();
    },
    /**
     *
     */
    authResponse: function() {
        PubSub.trigger('directRoute', 'closeCurrentModal');
    },
    /**
     *
     */
    facebookResponse: function(response) {
        if(response.status == 'connected') {
            PubSub.trigger('directRoute', 'closeCurrentModal');
        } else {
            // handle when a user does not update the login information for FB
        }
    },
    /**
     * Google Sign In
     */
    googleSignIn: function(e) {
        var omParams = { name: 'google sign in button', section: 'login-modal', url: window.location.href };

        PubSub.trigger('linkClick', omParams);
    },
    /**
     * [authenticateEmail description]
     * @param  {[type]} e [description]
     * @return {[type]}   [description]
     */
    authenticateEmail: function(e) {
        e.preventDefault();
        e.stopPropagation();
        var email = $('input[type=email]').val();

        if(!this.validateEmail()) return;

        var omParams = { name: 'email login button', section: 'login-modal', url: window.location.href };
        var gaParams = { eventCategory: 'Button Click', eventAction: 'Login Email' };

        PubSub.trigger('linkClick', omParams, gaParams);
        PubSub.trigger('emailLogin', email.toLowerCase().trim());
        PubSub.trigger('directRoute', 'closeCurrentModal');
    },
    /**
     * Validate the email input and adjust errors
     */
    validateEmail: function() {
        var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        var email = $('input[type="email"]').val();

        if(!re.test(email.trim())) {
            $('input[type=email]').addClass('error-formbox');
            this.$('.error-message').show();
            return false;
        } else {
            $('input[type=email]').removeClass('error-formbox');
            this.$('.error-message').hide();
            return true;
        }
    },
    /**
     * [displayEmailError description]
     * @return {[type]} [description]
     */
    displayEmailError: function() {
    },
    /**
     * [closeModal description]
     * @return {[type]} [description]
     */
    closeModal: function(e) {
        e.preventDefault();
        e.stopPropagation();
        PubSub.trigger('userCancelAuth');
        PubSub.trigger('directRoute', 'closeCurrentModal');
    },
    /**
     * handleAnchorClick
     * @param {object} e - event object
     */
    handleAnchorClick: function( e ) {
        var val = e.target.innerText;
        var href = e.currentTarget.href;

        var omParams = { name: 'link: ' + val, section: 'login-modal', destination: href };
        var gaParams = { eventCategory: 'Link Click', eventAction: 'Auth Link Click' };

        PubSub.trigger( 'linkClick', omParams, gaParams);
    }
});



// WEBPACK FOOTER //
// ./app/scripts/views/auth.js